import React from 'react';

export default function SignInWrapper({ children }) {
  return <>{children}</>;
}
